import { Company } from "./Company";

export class Profile {
  public constructor(
    public id = 0,
    public firstname = "",
    public lastname = "",
    public username = "",
    public email = "",
    public picture = "",
    public uuid = "",
    public role = "",
    public lang = "",
    public company = new Company()
  ) {}
}
